import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlElement } from "./HtmlElement";
import { Languages } from "../../Utils/Languages";
import { HtmlController } from "../HtmlController";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlLabelElement extends HtmlElement {
    for: string;
    text: string;

    constructor() {
        super();
    }

    create(node: Element): void {
        super.create(node);

        if (node.hasAttribute("For")) {
            this.for = node.getAttribute("For");
        }

        this.createLabel();

        if (this.instance != null) {
            this.instance.parentElement.removeChild(this.instance);
        }
    }

    private createLabel(): void {
        let holder = this.instance.parentElement;
        let toggleSwitch: HTMLDivElement = <HTMLDivElement>document.createElement("div");
        let label: HTMLLabelElement = <HTMLLabelElement>document.createElement("label");
        toggleSwitch.classList.add("toggleSwitch");
        label.htmlFor = this.for;
        label.innerHTML = this.instance.innerHTML;
        toggleSwitch.appendChild(label);

        if (this.instance != null) {
            holder.firstChild.appendChild(toggleSwitch);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlLabelElement.ts
 **/